export default __webpack_public_path__ + "static/media/sticky_note_2-24px.1ccfe343.svg";